import React from "react";
import {convertHexToRgba, isMobile} from "../App/utils";
import {colorPaper} from "../App/theme";
import Paper from "@mui/material/Paper";

export function PaperWrapper({ children, style }) {
    return isMobile ? children : (
        <Paper elevation={1} sx={style ? style : {
            padding: '24px',
            backgroundColor: convertHexToRgba(colorPaper)
        }}>
            {children}
        </Paper>
    );
}